"use client";

import React, { useState, useEffect } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, FileText, ChevronLeft, ChevronRight } from "lucide-react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
export default function TheAnalyticalEdge() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const equipmentImages = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/WhatsApp Image 2026-05-12 at 13.00.18.jpg",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/WhatsApp Image 2026-05-12 at 13.00.18.jpg-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/WhatsApp Image 2026-05-12 at 13.00.18.jpg-wvc-sizes",
    alt: "Regional trade coordination hub"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/WhatsApp Image 2026-05-11 at 17.41.15.jpg",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/WhatsApp Image 2026-05-11 at 17.41.15.jpg-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/WhatsApp Image 2026-05-11 at 17.41.15.jpg-wvc-sizes",
    alt: "Factory equipment photo 2"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/WhatsApp Image 2026-05-12 at 13.00.18 (1).jpg",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/WhatsApp Image 2026-05-12 at 13.00.18 (1).jpg-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/WhatsApp Image 2026-05-12 at 13.00.18 (1).jpg-wvc-sizes",
    alt: "Industrial oil processing facility"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/WhatsApp Image 2026-05-12 at 13.00.19.jpg",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/WhatsApp Image 2026-05-12 at 13.00.19.jpg-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/WhatsApp Image 2026-05-12 at 13.00.19.jpg-wvc-sizes",
    alt: "Logistics and storage infrastructure"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/ChatGPT Image May 12, 2026, 06_24_06 PM.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/ChatGPT Image May 12, 2026, 06_24_06 PM.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/ChatGPT Image May 12, 2026, 06_24_06 PM.png-wvc-sizes",
    alt: "Industrial processing unit"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/ChatGPT Image May 12, 2026, 06_26_41 PM.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/ChatGPT Image May 12, 2026, 06_26_41 PM.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/ChatGPT Image May 12, 2026, 06_26_41 PM.png-wvc-sizes",
    alt: "Logistics coordination center"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/ChatGPT Image May 12, 2026, 06_30_07 PM.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/ChatGPT Image May 12, 2026, 06_30_07 PM.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/ChatGPT Image May 12, 2026, 06_30_07 PM.png-wvc-sizes",
    alt: "Biofuel feedstock storage"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/ChatGPT Image May 12, 2026, 06_33_23 PM.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/ChatGPT Image May 12, 2026, 06_33_23 PM.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/ChatGPT Image May 12, 2026, 06_33_23 PM.png-wvc-sizes",
    alt: "Maritime export terminal"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/ChatGPT Image May 12, 2026, 06_36_22 PM.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/ChatGPT Image May 12, 2026, 06_36_22 PM.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/ChatGPT Image May 12, 2026, 06_36_22 PM.png-wvc-sizes",
    alt: "Quality control laboratory"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/ChatGPT Image May 12, 2026, 06_42_05 PM.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/ChatGPT Image May 12, 2026, 06_42_05 PM.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/ChatGPT Image May 12, 2026, 06_42_05 PM.png-wvc-sizes",
    alt: "Industrial processing facility and storage tanks"
  }];
  const nextImage = () => {
    setCurrentImageIndex(prev => (prev + 1) % equipmentImages.length);
  };
  const prevImage = () => {
    setCurrentImageIndex(prev => (prev - 1 + equipmentImages.length) % equipmentImages.length);
  };
  useEffect(() => {
    equipmentImages.forEach(image => {
      const img = new Image();
      img.src = image.src;
    });
  }, []);
  return <section data-section-id="230314" id="industrial-supply-operations" className="bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none bg-[radial-gradient(circle_at_center,_var(--color-primary)_1px,_transparent_1px)] bg-[size:32px_32px]"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 gap-6 sm:gap-8 md:gap-12 lg:gap-20 items-center">
          
          <Dialog open={isModalOpen} onOpenChange={setIsModalOpen}>
            <DialogContent className="max-w-4xl p-0 overflow-hidden bg-transparent border-none">
              <div className="relative w-full h-full flex flex-col items-center justify-center gap-4">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/ISCC_EU_CRT_OWCL_081826.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/ISCC_EU_CRT_OWCL_081826.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/ISCC_EU_CRT_OWCL_081826.png-wvc-sizes" alt="ISCC Certification Certificate Full View" className="max-h-[85vh] w-auto rounded-md shadow-2xl" loading="lazy" />
                <Link to="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/ISCC_EU_CRT_OWCL_081826.png" newTab className="text-white underline text-sm font-medium">
                  Open in new tab
                </Link>
              </div>
            </DialogContent>
          </Dialog>

          <div ref={contentRef} className={`flex flex-col justify-center transition-all duration-1000 delay-200 ease-out order-1 lg:order-1 ${isContentVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="bg-card/40 backdrop-blur-sm border border-border/40 rounded-lg p-4 sm:p-6 md:p-10 lg:p-12 shadow-md space-y-8">
              <div className="space-y-6">
                <h2 className="font-default text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold tracking-tighter text-primary">About Us</h2>
                
                <div className="space-y-6 text-base sm:text-lg md:text-xl text-muted-foreground leading-relaxed font-default">
                  <p>Oriental World Corporation Limited specializes in the sourcing and regional coordination of industrial oils and biofuel feedstocks across the Far East.<br /><br />With over 18 years of experience in oil manufacturing and commodity trading, Oriental World continues a longstanding tradition of industrial supply, international trade, and cross-border market development.<br /><br />Following a strategic rebranding initiative in 2025, our business expanded its international positioning under the Oriental World identity.</p>
                  <p>Our operations support the handling and export coordination of industrial bovine and sheep tallow, used cooking oil (UCO), and animal and vegetable acid oil, mixed acid oil (MAO) and plant-based oil for renewable fuel and industrial applications.</p>
                  <p>From Hong Kong port logistics to inland industrial coordination, we work with suppliers, processors, and downstream buyers across East and Southeast Asia.</p>
                  <p>With ISCC-certified operations and regional market experience, we focus on reliable supply coordination, practical logistics management, and long-term industry partnerships.</p>
                  
                  <div className="pt-4 flex flex-wrap gap-4">
                    <Link to="https://trusting-sunbird.10web.cloud/markets/">
                      <Button size="lg" className="group rounded-md px-8">
                        View Our Markets
                        <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                      </Button>
                    </Link>
                    <Button size="lg" variant="outline" className="group rounded-md px-8" onClick={() => setIsModalOpen(true)}>
                      View ISCC Certificate
                      <FileText className="ml-2 h-4 w-4" />
                    </Button>
                  </div>

                  <div className="mt-12 flex flex-col items-center gap-4">
                    <div className="relative w-full max-w-[600px] mx-auto overflow-hidden rounded-lg border border-border/50 shadow-lg bg-muted">
                      <img src={equipmentImages[currentImageIndex].src} data-wvc-srcset={equipmentImages[currentImageIndex].srcset} data-wvc-sizes={equipmentImages[currentImageIndex].sizes} alt={equipmentImages[currentImageIndex].alt} className="w-full h-auto object-contain transition-opacity duration-500" loading="eager" />
                    </div>

                    <div className="flex sm:hidden gap-1.5 items-center justify-center py-2">
                      {equipmentImages.map((_, idx) => <Button key={idx} data-index={idx} variant="ghost" size="sm" onClick={() => setCurrentImageIndex(idx)} className={`h-2 w-2 min-w-0 p-0 rounded-lg transition-all duration-300 ${currentImageIndex === idx ? "bg-primary w-4" : "bg-muted-foreground/30"}`} aria-label={`Go to slide ${idx + 1}`} />)}
                    </div>

                    <div className="flex sm:hidden items-center justify-center text-sm font-medium">
                      {currentImageIndex + 1} / {equipmentImages.length}
                    </div>

                    <div className="hidden sm:flex gap-2 items-center">
                      {equipmentImages.map((_, idx) => <Button key={idx} data-index={idx} variant={currentImageIndex === idx ? "default" : "outline"} size="sm" onClick={() => setCurrentImageIndex(idx)} className={`h-8 w-8 min-w-0 p-0 rounded-lg transition-all duration-300 font-bold text-xs ${currentImageIndex === idx ? "bg-primary text-primary-foreground" : "text-muted-foreground border-border/50"}`} aria-label={`Go to slide ${idx + 1}`}>
                          {idx + 1}
                        </Button>)}
                    </div>

                    <div className="flex items-center gap-4">
                      <Button variant="outline" size="icon" className="rounded-lg border-border/50" onClick={prevImage}>
                        <ChevronLeft className="h-5 w-5" />
                      </Button>
                      <Button variant="outline" size="icon" className="rounded-lg border-border/50" onClick={nextImage}>
                        <ChevronRight className="h-5 w-5" />
                      </Button>
                    </div>

                    <div className="flex justify-center mt-8 w-full">
                      <Link to="https://trusting-sunbird.10web.cloud/products/">
                        <Button size="lg" className="group rounded-md px-8">
                          View Products
                          <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                        </Button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}